import { TxType } from '@/types/types'
import { ElMessage } from 'element-plus'

/**
 * 交易组样式
 * @export
 * @param {{ row: TxType }} arr
 * @returns {(string | undefined)}
 */
export function groupCellName(arr: { row: TxType }): string | undefined {
  switch (arr.row.tradeG) {
    case 0:
      break;
    case 1:
      return 'tx-middle'
    case 2:
      return 'tx-end'
    case 3:
      return 'tx-start'
    default:
      break;
  }
}


/**
 * 检测交易类型
 * @export
 * @param {TxType[]} arr
 * @returns {TxType[]}
 */
export function checkGroup(arr: TxType[]): TxType[] {
  arr.map((current, index: number) => {
    const { groupCount, fee, next } = current.tx ? {
      groupCount: current.tx.groupCount,
      fee: current.tx.fee,
      next: current.tx.next
    } : {
      groupCount: current.group_count,
      fee: current.fee,
      next: current.next
    }
    if (groupCount > 1) {
      current.tradeG = 1 //0-非交易组，1-交易组，3-交易组末条, 2-交易组首条
      if (fee !== 0) {
        current.tradeG = 2
      } else {
        if (index < arr.length) {
          current.tradeG = !next ? 3 : 1
        } else {
          current.tradeG = 3
        }
      }
    } else {
      current.tradeG = 0
    }
  })
  return arr
}

export function success(): void {
  ElMessage.success('复制成功')
}

export function error(): void {
  ElMessage.warning('复制失败')
}